export const RADIAN = Math.PI / 180;

export const TEMPLATE_EXTENSIONS = [".doc", ".docx", ".html"];
